import {F_ERR_ENUM} from "../enum/field-error.enum";
let translateMethod = (...args) => {
  return args.join(', ');
};
export const ErrorManager = {
  setTranslateMethod (fn) {
    translateMethod = fn;
  },
  factory (source, message) {
    return {
      source,
      message
    }
  },
  filter (arrayOrErrors, source) {
    if (source === F_ERR_ENUM.ALL) {
      return ErrorManager.cleanup(arrayOrErrors);
    }
    return arrayOrErrors.filter(e => e.source !== source);
  },
  add (arrayOfErrors, error) {
    const result = ErrorManager.filter(arrayOfErrors, error.source);
    result.push(error);
    return result;
  },
  cleanup (arrayOfErrors) {
    return [];
  },
  display (arrayOfErrors) {
    return arrayOfErrors.map(e =>{
      if (translateMethod(e.message)) {
        return translateMethod(e.message);
      }
      return e.message;
    }).join('. ');
  }
};



// WEBPACK FOOTER //
// ./src/helpers/field-error.js